export default function Card({ children, className = "", onClick }) {
    return (
      <div 
        onClick={onClick}
        className={`card ${onClick ? "card--clickable" : ""} ${className}`.trim()}
      >
        {children}
      </div>
    );
  }